/* eslint-disable import/extensions */
import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShButton from '@/components/Helpers/ShButton';
import TheMainLogo from '@/components/Platform/TheMainLogo';
import TheMainMenu from '@/components/Platform/TheMainMenu';
import TheMobileMenu from '@/components/Platform/TheMobileMenu';
import TheControlsAndAccountSettings from '@/components/Platform/TheControlsAndAccountSettings';

// @vue/component
export default {
  name: 'TheHeader',

  components: {
    ShUserAvatar,
    ShButton,
    TheMainLogo,
    TheMainMenu,
    TheMobileMenu,
    TheControlsAndAccountSettings,
  },

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'medium',
    },
  },


  methods: {
    handleLogout() {
      this.$auth.logoutFromPlatform();
    },

    handleToggleMenu() {
      this.$store.dispatch('app/toggleMenu');
    },
  },
};
